import i18n from 'config/i18n';
import * as yup from 'yup';
import { getLocale } from 'utils/date';
import { ClaResponse } from 'generated/index';
import {
  EXTERNAL_CODE_MAX_LENGTH,
  externalCodeToSave
} from './ClaMaintenance.externalCode';

const t = i18n.getFixedT(getLocale());

const buildSchema = (
  rows: ClaResponse[],
  currentClaId: number | undefined,
  storedExternalCode: string | undefined
) =>
  yup.object({
    code: yup
      .string()
      .trim()
      .required(
        t('validationFieldRequired', {
          name: t('adminPortal.claMaintenance.code')
        })
      )
      .max(
        10,
        t('validationMaxCharacters', {
          name: t('adminPortal.claMaintenance.code'),
          number: 10
        })
      )
      .test('unique-code', t('formErrors.duplicateCode'), (value) => {
        if (!value) return true;
        // Compared exactly, like the database does: aux_cla_code_idx (353.xml) and
        // ClaMapper.selectByClaCode are both case-sensitive. Ignoring case here would
        // leave a tenant that already has 'KO' and 'ko' unable to save either row.
        return !rows.some(
          (row) => row.claId !== currentClaId && row.claCode?.trim() === value
        );
      }),
    name: yup
      .string()
      .trim()
      .required(
        t('validationFieldRequired', {
          name: t('adminPortal.claMaintenance.name')
        })
      )
      .max(
        5,
        t('validationMaxCharacters', {
          name: t('adminPortal.claMaintenance.name'),
          number: 5
        })
      ),
    externalCode: yup
      .string()
      .trim()
      .nullable()
      // The stored value is what has to fit varchar(25), and that is the value
      // with its '#'-delimiters — hence a message that says so rather than the
      // generic one, which would report "at most 25" for 24 typed characters.
      .test(
        'external-code-max-length',
        t('adminPortal.claMaintenance.externalCodeMaxLength', {
          number: EXTERNAL_CODE_MAX_LENGTH
        }),
        (value) =>
          (externalCodeToSave(value, storedExternalCode)?.length ?? 0) <=
          EXTERNAL_CODE_MAX_LENGTH
      ),
    isDefault: yup.boolean().required()
  });

export default buildSchema;
